import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  regex: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('regex');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.regex.length > 0 ? action.regex : [];  
  return updateObject(state, {
    regex: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, regex:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REGEX_START:
      return fetchStart(state);
    case actionTypes.FETCH_REGEX_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_REGEX_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
